import React from 'react';
import '../App.css';
import './blog.css';
import { Helmet } from "react-helmet";
import { GiPalmTree } from "react-icons/gi";
import { useScrollBehavior } from './useScrollBehavior.js';
import { useNavigate } from 'react-router-dom';
import Footer from './footer4.js';

const Blog = () => {

  useScrollBehavior();

  const navigate = useNavigate();

  // Dummy data (swap with your real posts / API)
  const posts = [
    {
      slug: 'tree-trimming-sarasota',
      title: 'Tree Trimming in Sarasota: When and Why It Matters',
      date: 'January 10, 2026',
      excerpt:
        "Proper trimming keeps trees healthy, reduces storm risk, and improves curb appeal. Here’s what Sarasota homeowners should know."
    },
    {
      slug: 'stump-grinding-guide',
      title: 'Stump Grinding: What to Expect and How to Prepare',
      date: 'December 22, 2025',
      excerpt:
        "Stumps attract pests and get in the way. Learn how stump grinding works, typical timelines, and what happens to the mulch."
    },
    {
      slug: 'hurricane-season-tree-care',
      title: 'Hurricane Season Tree Care Checklist (Florida)',
      date: 'November 30, 2025',
      excerpt:
        "Before storms hit, handle dead limbs, weak branches, and risky overhangs. Use this checklist to reduce property damage."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Blog | Sam's Tree Service</title>
        <meta
          name="description"
          content="Read tree care tips, storm prep advice, and service guides from Sam's Tree Service in Sarasota, FL."
        />
        <link rel="canonical" href="https://samstreeservice.com/blog" />
      </Helmet>

      <div id="main_blogDiv">
        <div className="background-imageblog"></div>

        {/* HERO */}
        <div className="module_blog" id="module_blog1">
          <div id="blog_div1">
            <div id="cover_blog_div1">
              <div id="blog_title">
                <h1>Blog</h1>
              </div>
            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div className="module_blog" id="module_blog2">
          <div id="blog_div3">
            <div id="blogcontent_div">
              {/* LEFT / INTRO (mirrors your contact left column style) */}
              <div id="blog_div3_text_10_container">
                <div id="blog_div3_text_10">
                  <div id="icon_blog_div3_text_10">
                    <div id="blog_div3_text_10_text2_1">
                      <h1> - - - - - -&nbsp;&nbsp;</h1>
                    </div>
                    <div id="blog_div3_text_10_half_icon2">
                      <GiPalmTree />
                    </div>
                    <div id="blog_div3_text_10_text2_2">
                      <h1>&nbsp;- - - - - -</h1>
                    </div>
                  </div>

                  <div id="icon_blog_div3_text_10_subtext">
                    <h1>Tree Care Tips & Updates</h1>
                    <p>
                      Practical guides, storm prep checklists, and answers to common questions from
                      <strong> Sam&apos;s Tree Service</strong>. Serving Sarasota and surrounding areas.
                    </p>
                  </div>

                  <div
                    className="blog_div3_subdiv"
                    onClick={() => {
                          navigate('/contact');
                          window.scrollTo(0, 0);
                          }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="circle_icon_blog_div3">+</div>
                    <div className="blog_div3_subdiv_text">
                      <h1>Get a Free Estimate</h1>
                      <p>Fast scheduling + reliable work</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT / POSTS (mirrors your ContactForm container sizing) */}
              <div id="blog_posts_container">
                <div id="blog_posts_header">
                  <h2>Latest Posts</h2>
                </div>

                <div id="blog_posts_list">
                  {posts.map((post) => (
                    <article
                      key={post.slug}
                      className="blog_post_card"
                      onClick={() => (window.location.href = `/blog/${post.slug}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="blog_post_card_inner">
                        <h3 className="blog_post_title">{post.title}</h3>
                        <p className="blog_post_date">{post.date}</p>
                        <p className="blog_post_excerpt">{post.excerpt}</p>
                        <div className="blog_post_cta_row">
                          <button className="blog_readmore_btn" type="button">
                            Read More
                          </button>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Blog;

